<div class="check-in-error-container">
  <!-- Header -->
  <div class="dialog-header">
    <h2 class="dialog-title">CHECKIN</h2>
  </div>

  <!-- Visit Information -->
  <div class="visit-info">
    <div class="info-grid">
      <div class="info-item">
        <span class="info-label">Subject ID:</span>
        <span class="info-value">{{ data?.subjectId || 'N/A' }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">Visit:</span>
        <span class="info-value">{{ data?.visitName || 'N/A' }}</span>
      </div>
      @if (data?.studyNumber) {
        <div class="info-item">
          <span class="info-label">Study:</span>
          <span class="info-value">{{ data.studyNumber }}</span>
        </div>
      }
      @if (data?.visitDate) {
        <div class="info-item">
          <span class="info-label">Visit Date:</span>
          <span class="info-value">
            {{ data.visitDate | dateTransform:'dd MMM yyyy' }} 
            ({{ (data.visitDate | date:'h:mma') | uppercase }}@if (data.visitEndDate) {-{{ (data.visitEndDate | date:'h:mma') | uppercase }}})
          </span>
        </div>
      }
    </div>
  </div>

  <!-- Personnel Section -->
  <div class="personnel-section">
    @if (noSignatureStepsError) {
      <div class="no-signature-steps-error">
        <p class="error-message-text">{{ noSignatureStepsError }}</p>
      </div>
    } @else if (workflowSteps.length === 0) {
      <p class="text-sm text-gray-600">No personnel configuration found.</p>
    } @else {
      <div class="personnel-list">
        @for (step of workflowSteps; track step.roleId; let i = $index) {
          <div class="personnel-item">
            <label class="personnel-label">{{ step.stepLabel }}:</label>
            
            <div class="personnel-select-wrapper">
              <select 
                class="personnel-select"
                [ngModel]="step.selectedUserId"
                (ngModelChange)="onPersonnelChange(i, $event)"
                (focus)="onPersonnelDropdownFocus(i)"
                [disabled]="isUpdating"
                [class.error-border]="hasStepError(step)"
              >
                <option [ngValue]="null">-- Select --</option>
                @for (person of step.personnel; track person.userId) {
                  <option [ngValue]="person.userId">
                    {{ getFullName(person) }}
                  </option>
                }
              </select>
            </div>
            
            @if (hasStepError(step) || step.errorReason) {
              <div class="error-message">
                @if (hasStepError(step)) {
                  {{ getStepErrorMessage(step) }}
                } @else if (step.errorReason) {
                  {{ step.errorReason }}
                }
              </div>
            }
            
            @if (step.personnel.length === 0) {
              <p class="warning-text">No available personnel for this role</p>
            }
          </div>
        }
      </div>
    }
  </div>

  <!-- Error Message (Mobile) -->
  @if (hasError || noSignatureStepsError) {
    <div class="action-error-mobile">
      @if (noSignatureStepsError) {
        {{ noSignatureStepsError }}
      } @else {
        Please review and try again.
      }
    </div>
  }

  <!-- Actions -->
  <div class="dialog-actions">
    @if (hasError || noSignatureStepsError) {
      <div class="action-error">
        Please review and try again.
      </div>
    }
    <button 
      mat-button 
      (click)="onClose()"
      [disabled]="isUpdating"
    >
      Cancel
    </button>
    <button 
      mat-flat-button 
      color="primary"
      (click)="onUpdateAndRetry()"
      [disabled]="isUpdating || hasAnyError()"
    >
      @if (isUpdating) {
        <mat-spinner diameter="20" class="inline-spinner"></mat-spinner>
        Saving...
      } @else {
        Save & Continue
      }
    </button>
  </div>
</div>

